import AxiosInstance from 'config/apiServiceApiGateway'
import { Get } from 'config/apiServiceConfig'
import { ProductCategoryType, RlPicType, TagType } from '../types/rlFilter'
import { DeleteReasonType } from '../types/rlSourcing'

export const fetchPicListApi = (params: { name: string }) =>
  Get<{ content: RlPicType[] }>({
    url: `/api/product/catalog/pic`,
    params: { ...params, pageIndex: 0, pageSize: 20 },
  })

export const getProductCategoryApi = (name: string) =>
  Get<{ content: ProductCategoryType[] }>({ url: '/api/category', params: { name } })

export const fetchRlDeleteReasonsApi = () =>
  AxiosInstance.Get<{ data: DeleteReasonType[] }, true>({
    url: `/commercial/internal/v1/reason/REORDER_LIST`,
  })

export const fetchRlTagsApi = () =>
  AxiosInstance.Get<{ data: TagType[] }, true>({
    url: `/commercial/internal/v1/reorder-list/tags`,
  })
